<!--
@视频播放组件
-->
<template>
  <div class="VideoPlayer">
    <el-dialog :visible.sync="dialogVisible" :title="title" width="50%" :before-close="closeVideo">
      <video-player class="vjs-custom-skin" ref="videoPlayer" :options="playerOptions" :playsinline="true" @ended="onPlayerEnded($event)"></video-player>
    </el-dialog>
  </div>
</template>

<script>
import { videoPlayer } from 'vue-video-player';
export default {
  name: 'VideoPlayer',
  props: ['progress'],
  data() {
    return {
      title: '播放',
      dialogVisible: false,
      playerOptions: {
        height: '500',
        autoplay: true, //如果true,浏览器准备好时开始回放(自动播放)。
        muted: false, // 静音
        preload: 'auto', /// 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        live: false,
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        /* sources: [
          {
            type: 'application/x-mpegURL',
            //src: this.videoURL
            src:'http://localhost:9000/admin/static/hls/8/8.m3u8'
          }
        ], */
        notSupportedMessage: '此视频暂无法播放，请稍后再试',
        poster: '../../../assets/image/logo.png', // 封面地址
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
          progressControl: this.progress
        }
      }
    };
  },

  components: {
    videoPlayer
  },

  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    }
  },

  created() {},

  mounted() {},

  methods: {
    // 播放介绍
    onPlayerEnded(player) {
      this.$emit('ended', player);
    },
    // 关闭视频弹窗前先调用父组件的清除视频URL方法然后再关闭弹窗
    closeVideo() {
      this.$emit('time', this.getCurrentTime());
      const player = this.$refs.videoPlayer.player;
      player.pause();
      this.dialogVisible = false;
    },
    // 打开视频播放弹窗
    openVideoDialog(url, title, controls) {
      this.dialogVisible = true;
      this.$nextTick(() => {
        if (title) {
          this.title = title;
        }
        const player = this.$refs.videoPlayer.player;
        // 控制面板
        if (controls != undefined) {
          player.controls(false);
        }
        player.src(url);
        player.load(url);
        player.load();
      });
    },
    getCurrentTime() {
      //当前播放时长(秒)
      if (this.$refs.videoPlayer == undefined) {
        return null;
      }
      const player = this.$refs.videoPlayer.player;
      if (player) {
        var currentTime = Math.floor(player.currentTime());
        return currentTime;
      }
      return null;
    },
    setCurrentTime(time) {
      //当前播放时长(秒)
      this.$nextTick(() => {
        const player = this.$refs.videoPlayer.player;
        player.load();
        player.currentTime(time);
      });
    }
  }
};
</script>

<style scoped>
.VideoPlayer {
}
</style>



// WEBPACK FOOTER //
// src/components/VideoPlayer/index.vue